import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FiltersContext } from '../../filters/context';
import { buildOrdersGridRequestFiltersFromState } from '../../orders/services/orders-grid-request-service';
import { useLocation } from 'react-router-dom';

export const useOrdersGridFilters = () => {
  const { buildApiFilters } = useContext(FiltersContext);
  const { pathname } = useLocation();

  return useSelector((state) => buildOrdersGridRequestFiltersFromState(state, buildApiFilters(), pathname));
};
